import { render, staticRenderFns } from "./CallPatient.vue?vue&type=template&id=602eb07a&lang=pug&"
import script from "./CallPatient.vue?vue&type=script&lang=js&"
export * from "./CallPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports